import React, { useState } from 'react'
// styles & components
import './Login.css'
// import '../Signup/Signup.css'

// hooks
import { useAuthLogin } from '../../Hooks/useAuthLogin'


export default function Login() {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  const { login, isPending, error } = useAuthLogin()

  // submit form
  const handleSubmit = (e) => {
    e.preventDefault()
    login(email, password)
    // setEmail('')
    // setPassword('')
  }

  return (
    <form className='auth-form' onSubmit={handleSubmit}>
      <h2>Sign in</h2>
      
      <label>
        <span>Email:</span>
        <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} />
      </label>
      <label>
        <span>Password:</span>
        <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} />
      </label>
      {!isPending && <button type='submit' className='btn'>Sign in</button>}
      {isPending && <button  disabled className='btn'>Loading...</button>}
      { error && <div className="error">{error}</div> }
    </form>
  )
}
